
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const AnalysisResult = lazy(() => import('../pages/analysis-result/page'));
const SkincareRoutine = lazy(() => import('../pages/skincare-routine/page'));
const Checklist = lazy(() => import('../pages/checklist/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/analysis-result',
    element: <AnalysisResult />,
  },
  {
    path: '/skincare-routine',
    element: <SkincareRoutine />,
  },
  {
    path: '/checklist',
    element: <Checklist />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
